import { render, staticRenderFns } from "./_FrequentlyUsed.vue?vue&type=template&id=18976e7f&"
import script from "./_FrequentlyUsed.vue?vue&type=script&lang=js&"
export * from "./_FrequentlyUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports